// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__1py-W","gameImg":"card_gameImg__Rpq_6","gameInfo":"card_gameInfo__3csKn"};